import { render, staticRenderFns } from "./ShootingChart.vue?vue&type=template&id=6faf725e&scoped=true&"
import script from "./ShootingChart.vue?vue&type=script&lang=js&"
export * from "./ShootingChart.vue?vue&type=script&lang=js&"
import style0 from "./ShootingChart.vue?vue&type=style&index=0&id=6faf725e&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faf725e",
  null
  
)

export default component.exports